export enum TeamHealthActions {
  RefetchTeamHealth = "TeamHealth_Refetch",
}

export const refetchSummary = () => {
  return {
    type: TeamHealthActions.RefetchTeamHealth,
  };
};
